<template>
    <footer>
    <div class="container">
    <div class="row">
        <div class="col-md-3 text-center">
            <a href="https://www.auladerechodeautor.org">
                <img :src="'/static/' + currentLocale + '/logo.png'" class="logo-footer">
            </a>
        </div>
        <div class="col-md-3">
            <h4>{{ $t('footer.contact', currentLocale) }}</h4>
            <p>Alcalá, 21, 2.º dcha.<br>28014 Madrid</p>
        </div>
        <div class="col-md-3">
            <h4>{{ $t('footer.info', currentLocale) }}</h4>
            <ul>
                <li><router-link :to="{path: '/' + currentLocale + '/autores'}">{{ $t('footer.tekijat', currentLocale) }}</router-link></li>
                <li><router-link :to="{path: '/' + currentLocale + '/condiciones-de-uso'}">{{ $t('footer.kayttoehdot', currentLocale) }}</router-link></li>
                <li><router-link :to="{path: '/' + currentLocale + '/cookies'}">{{ $t('footer.evasteet', currentLocale) }}</router-link></li>
                <li><router-link :to="{path: '/' + currentLocale + '/accesibilidade'}">{{ $t('footer.saavutettavuus', currentLocale) }}</router-link></li>
                <li><router-link :to="{path: '/' + currentLocale + '/politica-de-privacidade'}">{{ $t('footer.yksityisyys', currentLocale) }}</router-link></li>
            </ul>
        </div>    
        <div class="col-md-3">
            <h4>{{ $t('footer.some', currentLocale) }}</h4>
            <a class="some" href="https://www.instagram.com/cedroenlinea" target="_blank">
                <img src="https://www.auladerechodeautor.org/wp-content/themes/kopiraittilankoulu/assets/icon-instagram.png" alt="Instagram">
	        </a>
            <a class="some" href="https://www.facebook.com/CEDROenlinea" target="_blank">
		        <img src="https://www.auladerechodeautor.org/wp-content/themes/kopiraittilankoulu/assets/icon-facebook.png" alt="Facebook">
	        </a>
            <a class="some" href="https://twitter.com/cedroenlinea" target="_blank">
                <img src="https://www.auladerechodeautor.org/wp-content/themes/kopiraittilankoulu/assets/icon-twitter.png" alt="Twitter">
	        </a>
            <a class="some" href="https://www.youtube.com/user/CEDROvideos" target="_blank">
                <img src="https://www.auladerechodeautor.org/wp-content/themes/kopiraittilankoulu/assets/icon-youtube.png" alt="Youtube">
	        </a>
            <a class="some" href="https://www.linkedin.com/company/cedro" target="_blank">
                <img src="https://www.auladerechodeautor.org/wp-content/themes/kopiraittilankoulu/assets/icon-linkedin.png" alt="Linkedin">
	        </a>
        </div>
       
    </div>
	<div class="row mt-5">
		<div class="mt-3 col-md-12 d-flex justify-content-center">
            <img src="https://www.auladerechodeautor.org/wp-content/themes/kopiraittilankoulu/assets/global/general/cedro_logo_white.png" width="150" height="53" style="margin: 0 40px;">
			<img src="https://www.auladerechodeautor.org/wp-content/themes/kopiraittilankoulu/assets/global/general/logotipo-mcd-web.png" width="317" height="43">
            <img src="https://www.auladerechodeautor.org/wp-content/themes/kopiraittilankoulu/assets/global/general/eu_logo_nextgen.png" width="256" height="37" style="margin: 0 40px;">
            <img src="https://www.auladerechodeautor.org/wp-content/themes/kopiraittilankoulu/assets/global/general/plan_de_recup_logo_es.png" width="207" height="58">
		</div>
	</div>
    <div class="row mt-5">
        <div class="col-md-12 text-center">
            <small>{{ $t('footer.copyright', currentLocale) }}</small>
        </div>
    </div>	
	</div>
    </footer>
</template>
<script>
  export default {
    computed: {
        currentLocale() {
            return this.$route.params.locale
        },
    },
    mounted () {
    },
    methods: {
      showLogin: function (event) {
        event.preventDefault()
        this.$emit('showLogin')
      }
    },
    computed: {
        currentLocale() {
            return this.$route.params.locale
        },
    },
  }
</script>

<style lang="scss">
    footer {
        padding: 4em 0;
        p {
            color: white;
            font-size: 1em;
        }
        a {
            color: white;
            &:hover {
                color: white;
            }
        }
        h4{
            font-size: 1em;
            font-weight: 700;
        }

        background: #231F20;
        color: white;
        .social-media-share {
            font-size: 18px;
            margin-bottom: 0.5rem;
        }
        .logo-footer {
            width: 50%;
            height: auto;
            margin: 0 auto;           
        }
        .some {
            img {
                width: 40px;
                margin: 0 0.25rem;
            }
        }
        ul {
            list-style: none;
            margin: 0;
            padding-left: 0;
            li {
                margin: 0;
                padding: 0;
                font-size: 1em;
                a {
                    color: white;
                }
            }
        }
        .footer-center {
            text-align: center;
            @media(max-width: 767.98px) {
                text-align: left;
            }
        }
        .footer-kopiosto {
            display:flex;
            align-items: center;
        }
        .copyright {
            text-align:center;
            margin-top:2rem;
            padding-bottom:5rem;
        }
    }

    @media(max-width: 767.98px) {
        footer {
            .footer-center {
                text-align: left;
            }
            ul {
                padding-left: 0;
                li {
                    margin: 0;
                }
            }
            .link-forgotten {
                margin: 2rem 0;
            }
            .copyright {
                text-align:left;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/components/Footer.vue